export default __webpack_public_path__ + "static/media/KFOmCnqEu92Fr1Mu4mxKKTU1Kg.cfba0239.woff2";